import * as lib from '~/dependencies';

export const PhoneContainer = lib.styled.div`
    display: flex;
    flex: 1;
    width: 100%;
    flex-direction: column;
    position: relative;
    overflow: hidden!important;

    &::-webkit-scrollbar { width: 0!important }
    overflow: -moz-scrollbars-none!important; }
    -ms-overflow-style: none!important; }
`;

export const ContainerHistory = lib.styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow: hidden;
`;

export const HistoryCustomFiltersButton = lib.styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    margin-left: -10px;
    cursor: pointer;
`;
